import React, { useState } from "react";
import { Form, Input, Button } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { login } from "../../../reducers/loggedinuser";
import { storeToken, loginAuth } from "../../../services/AuthServices";
import Alert from "../../common/alert";
import "./login.css";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const {isLoggedIn,userOptions} = useSelector((state) => state.auth);

  const [authType, setAuthType] = useState("TRAINER");
  const [formInstance] = Form.useForm();

  const handleSubmit = () => {
    formInstance.validateFields().then((values) => {
      loginAuth(values.email, values.password, authType)
        .then((response) => {
          if (response.data.success) {
            dispatch(login(response.data.user));
            storeToken(response.data.token);
          } else {
            Alert(
              "error",
              "Error!",
              response.data.message.replaceAll("TRAINER", "TEACHER")
            );
          }
        })
        .catch((error) => {
          const message = error.response
            ? error.response.data.message
            : error.message;
          Alert("error", "Error!", message);
        });
    });
  };

  const changeAuthType = (selected) => {
    if (["ADMIN", "TRAINER", "STUDENT"].includes(selected)) {
      setAuthType(selected);
    }
  };

  if (isLoggedIn && userOptions?.[0]?.link) {
    navigate(userOptions[0].link);
    return null;
  }

  return (
    <div className="login-container">
      <div className="login-inner">
        <h1>Sign In</h1>
        <div className="register_login_switch">
          <span
            onClick={() => changeAuthType("TRAINER")}
            className={`${authType === "TRAINER" ? "selected" : ""}`}
          >
            Teacher
          </span>
          <span
            onClick={() => changeAuthType("ADMIN")}
            className={`${authType === "ADMIN" ? "selected" : ""}`}
          >
            Admin
          </span>
        </div>
        <Form form={formInstance} onFinish={handleSubmit}>
          <Form.Item
            name="email"
            hasFeedback
            rules={[
              { type: "email", message: "The input is not valid E-mail!" },
              { required: true, message: "Please input your E-mail!" },
            ]}
          >
            <Input
              prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="Email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            hasFeedback
            rules={[{ required: true, message: "Please input your Password!" }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
              placeholder="Password"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Login
            </Button>
          </Form.Item>

          <div className="login-footer">
            <Link
              style={{ color: "black", textDecoration: "underline" }}
              to="/"
            >
              Student Sign In
            </Link>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Login;
